import { errorToast } from '../utils/toaster';
import { getAuth0Client } from './auth0';

const call = async ({
  path,
  fetchOptions,
  otherOptions = {},
  responseExpected = true,
  responseMethod = 'json'
}) => {
  const fetchOpts = {
    ...fetchOptions,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: undefined
    }
  };

  const auth0Client = getAuth0Client();
  const token = await auth0Client.getTokenSilently();

  if (token) {
    fetchOpts.headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(path, fetchOpts);
  if (res.ok && responseExpected) {
    return await res[responseMethod]();
  } else if (res.ok && !responseExpected) {
    return true;
  }

  // if response is 401 show a toast prompting the user to log back in
  if (res.status === 401 && !otherOptions.disable401Toast) {
    errorToast({ message: 'Got a 401 from API' });
    return false;
  }

  let errorBody = null;
  try { errorBody = await res.json(); } catch (_) {}
  console.warn('Error response', res);
  if (errorBody) console.warn('Error response body', errorBody);

  if (!otherOptions.disableErrorToasts) {
    const detail = errorBody?.message || errorBody?.error || res.statusText;
    errorToast({
      message: `${res.status}: ${detail}`
    });
  }
  throw new Error(res.status);
};

export { call };
